import { render, staticRenderFns } from "./GoodsStock.vue?vue&type=template&id=5781eeaa&scoped=true&"
import script from "./GoodsStock.vue?vue&type=script&lang=js&"
export * from "./GoodsStock.vue?vue&type=script&lang=js&"
import style0 from "./GoodsStock.vue?vue&type=style&index=0&id=5781eeaa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5781eeaa",
  null
  
)

export default component.exports